(function () {
  if (window.dsKlaviyoCartInitialized) return;
  window.dsKlaviyoCartInitialized = true;

  const EVENT = 'Warenkorb aktualisiert';
  const KEY = 'bv_kl_cart_sig_v2';
  const DELAY = 1500;
  let timer;
  let pending = false;
  let sending = false;
  let revision = 0;
  let retries = 0;
  let lastSignature;

  try { lastSignature = sessionStorage.getItem(KEY); } catch (_) {}

  function marketingAllowed() {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    return !privacy || typeof privacy.marketingAllowed !== 'function' || privacy.marketingAllowed();
  }

  function absoluteURL(path) {
    if (!path) return '';
    const url = new URL(path, window.location.origin);
    return ['https:', 'http:'].includes(url.protocol) ? url.href : '';
  }

  function imageURL(src) {
    const href = absoluteURL(src);
    if (!href) return '';
    const url = new URL(href);
    url.searchParams.set('width', '160');
    return url.href;
  }

  function snapshot(cart, drawer) {
    const value = cart.items_subtotal_price / 100;
    const total = cart.total_price / 100;
    const mode = drawer.dataset.klaviyoMinimumMode;
    const minimum = Number(drawer.dataset.klaviyoMinimumAmount);
    const minimumItems = Number(drawer.dataset.klaviyoMinimumItems);
    const missing = mode === 'amount' ? Math.max(0, Math.round(minimum * 100) - cart.items_subtotal_price) / 100 : 0;
    const missingItems = mode === 'amount' ? 0 : Math.max(0, minimumItems - cart.item_count);
    const reached = mode === 'amount' ? missing === 0 : missingItems === 0;
    const items = cart.items.map(item => ({
      product_id: item.product_id,
      variant_id: item.variant_id,
      title: item.product_title,
      variant: item.variant_title || '',
      quantity: item.quantity,
      line_price: item.final_line_price / 100,
      image: imageURL(item.image),
      url: absoluteURL(item.url || '/products/' + item.handle),
      abo: !!item.selling_plan_allocation,
      selling_plan_id: item.selling_plan_allocation?.selling_plan?.id || null,
      gift: !!item.properties?._custom_gift_step
    }));
    const event = {
      $value: value,
      CartTotal: total,
      Currency: cart.currency,
      MinimumMode: mode,
      MinimumAmount: minimum,
      MinimumItems: minimumItems,
      MissingToMinimum: missing,
      MissingItemsToMinimum: missingItems,
      MinimumReached: reached,
      ItemCount: cart.item_count,
      ItemNames: items.map(item => item.title),
      Items: items,
      CartURL: absoluteURL((window.Shopify?.routes?.root || '/') + 'cart')
    };
    return {
      event,
      signature: JSON.stringify(event),
      profile: {
        bv_cart_value: value,
        bv_cart_total: total,
        bv_cart_missing: missing,
        bv_cart_missing_items: missingItems,
        bv_cart_minimum_reached: reached,
        bv_cart_count: cart.item_count,
        bv_cart_items: items,
        bv_cart_updated: new Date().toISOString()
      }
    };
  }

  function schedule() {
    clearTimeout(timer);
    if (pending) timer = setTimeout(send, DELAY);
  }

  async function send() {
    const lac = window.liquidAjaxCart;
    if (!pending || sending || !lac || lac.processing || !marketingAllowed()) return;
    const drawer = document.querySelector('ds-cart-drawer');
    if (!drawer) return;
    const k = window.klaviyo;
    if (!k || !['isIdentified', 'identify', 'track'].every(method => typeof k[method] === 'function')) {
      if (retries++ < 3) schedule();
      return;
    }

    const currentRevision = revision;
    let retry = false;
    sending = true;
    try {
      if (!(await k.isIdentified())) return;
      if (currentRevision !== revision || lac.processing || !marketingAllowed()) return;
      const cart = lac.cart;
      if (!cart || !Array.isArray(cart.items) || !Number.isFinite(cart.items_subtotal_price) || !Number.isFinite(cart.total_price)) return;
      const data = snapshot(cart, drawer);
      if (data.signature === lastSignature) {
        pending = false;
        return;
      }
      if ((await k.identify(data.profile)) === false) throw new Error('Klaviyo identify failed');
      if (currentRevision !== revision || lac.processing || !marketingAllowed()) return;
      if ((await k.track(EVENT, data.event)) === false) throw new Error('Klaviyo track failed');
      lastSignature = data.signature;
      try { sessionStorage.setItem(KEY, lastSignature); } catch (_) {}
      if (currentRevision === revision) pending = false;
      retries = 0;
    } catch (_) {
      retry = retries++ < 3;
    } finally {
      sending = false;
      if (pending && (currentRevision !== revision || retry)) schedule();
    }
  }

  document.addEventListener('liquid-ajax-cart:queue-start', function () {
    revision += 1;
    clearTimeout(timer);
  });

  document.addEventListener('liquid-ajax-cart:request-end', function (event) {
    const state = event.detail?.requestState;
    if (!state || !['add', 'change', 'update', 'clear', 'get'].includes(state.requestType)) return;
    if (state.info?.cancel || !state.responseData?.ok || !event.detail.cart) return;
    if (state.requestType === 'get') {
      const drawer = document.querySelector('ds-cart-drawer');
      const previousCart = event.detail.previousCart;
      if (!drawer || !previousCart) return;
      try {
        if (snapshot(event.detail.cart, drawer).signature === snapshot(previousCart, drawer).signature) return;
      } catch (_) { return; }
    }
    pending = true;
    revision += 1;
    retries = 0;
    schedule();
  });

  document.addEventListener('liquid-ajax-cart:queue-end', schedule);
  document.addEventListener('visitorConsentCollected', function () {
    retries = 0;
    schedule();
  });
  window.addEventListener('klaviyoForms', function (event) {
    if (event.detail?.type === 'submit') {
      retries = 0;
      schedule();
    }
  });
  window.addEventListener('focus', function () {
    retries = 0;
    schedule();
  });
})();
